import { AlertState } from './model'
import { AppState } from '../../../types'

const getAll = (state: AppState): AlertState => state.monitoring.alert

export const getAlerts = (state: AppState) => getAll(state).alerts
export const getFilteredAlerts = (state: AppState) => getAll(state).filtered
export const isLoading = (state: AppState) => getAll(state).loading
export const getFilters = (state: AppState) => getAll(state).filters
export const isFiltering = (state: AppState) => {
  const filters = getAll(state).filters
  return filters.state !== 'ALL' || filters.severity !== 'ALL' || filters.resource !== 'ALL' || filters.search
}
